"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiText = exports.apiJson = exports.apiBuffer = exports.apiArrayBuffer = void 0;
const node_fetch_1 = __importDefault(require("node-fetch"));
const utils_1 = require("./utils");
async function apiArrayBuffer(url) {
    (0, utils_1.log)('⤓', url);
    return (0, node_fetch_1.default)(url).then((res) => res.arrayBuffer());
}
exports.apiArrayBuffer = apiArrayBuffer;
async function apiBuffer(url) {
    (0, utils_1.log)('⤓', url);
    return (0, node_fetch_1.default)(url).then((res) => res.buffer());
}
exports.apiBuffer = apiBuffer;
async function apiJson(url) {
    (0, utils_1.log)('⤓', url);
    return (0, node_fetch_1.default)(url).then((res) => res.json());
}
exports.apiJson = apiJson;
async function apiText(url) {
    (0, utils_1.log)('⤓', url);
    return (0, node_fetch_1.default)(url).then((res) => res.text());
}
exports.apiText = apiText;
//# sourceMappingURL=api.js.map